import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      padding: `${spacing.s}px ${spacing.m}px`,
      borderRadius: constants.radius.view,
    },
    subheader: {
      color: theme.text.secondary,
      fontSize: 12,
    },
    footerContainer: {
      justifyContent: "center",
      alignItems: "center",
      userSelect: "none",
      cursor: "pointer",
    },
    footer: {
      fontSize: 12,
      marginTop: 3,
    },
    info: {
      marginLeft: spacing.xxs,
      alignSelf: "center",
    },
  };

  return styles;
};
